<script>
export default {
    name: "Menus",
    data() {
        const self = this;
        return {
            menus: [],
            loading: true,
            showDialog: false,
            menu: {
                name: '',
                icon: '',
                type: 'menu',
                to: '',
                href: '',
                parent_id: '',
            },
            props: {
                children: 'menus',
                label: 'title'
            }
        }
    },
    methods: {
        fetchList() {
            this.$api.get('/menus').then(response => {
                this.menus = response.data;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        save() {
            const {menu} = this;
            if (!menu.name) {
                this.$message.error('Name is required');
                return;
            }

            if (menu.id) {
                this.$api.put(`/menus/${menu.id}`, menu).then(response => {
                    this.showDialog = false;
                    this.$message.success('Menu updated successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                this.$api.post('/menus', menu).then(response => {
                    this.showDialog = false;
                    this.$message.success('Menu saved successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            }

        },
        edit(data) {
            this.menu = data;
            this.showDialog = true;
        },
        remove(node, data) {
            this.$confirm('Are you sure to delete this menu?', 'Delete Menu', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$api.delete('/menus/' + data.id).then(response => {
                    this.$message.success('Menu deleted successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            });
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Menus</h2>
            <el-button type="primary" size="small" @click="showDialog=true;">Add Menu</el-button>
        </div>
        <section class="page-section" v-loading="loading">
            <el-tree
                :data="menus"
                node-key="id"
                :expand-on-click-node="false"
                :props="props"
                default-expand-all
            >
                <div class="custom-tree-node flex-grow-1 d-flex" slot-scope="{ node, data }">
                    <div class="flex-grow-1">{{ node.label }}</div>
                    <div>
                        <el-button
                            type="text"
                            size="mini"
                            @click="() => edit(data)">
                            Edit
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="() => remove(node, data)">
                            Delete
                        </el-button>
                    </div>
                </div>
            </el-tree>
        </section>
        <el-dialog
            title="Add Menu Group"
            closeable
            :visible.sync="showDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="true"
            :append-to-body="true"
            @close="showDialog=false"
            width="50%"
        >
            <el-form ref="form" size="medium" label-width="100px">
                <el-form-item label="Name">
                    <el-input v-model="menu.name" class="w200"></el-input>
                </el-form-item>
                <el-form-item label="Type">
                    <el-radio-group horizontal v-model="menu.type">
                        <el-radio label="module">Group</el-radio>
                        <el-radio label="menu">Link</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Parent" v-if="menu.type==='menu'">
                    <el-select v-model="menu.parent_id" placeholder="Select Parent" class="w200">
                        <el-option v-for="item in menus" :key="item.id" :label="item.title" :value="item.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="Icon" v-if="menu.type==='module'">
                    <el-input v-model="menu.icon" class="w200"></el-input>
                </el-form-item>
                <el-form-item label="Link To">
                    <el-input v-model="menu.to" class="w400"></el-input>
                </el-form-item>
                <el-form-item label="URL">
                    <el-input v-model="menu.href" class="w400"></el-input>
                </el-form-item>
                <el-form-item label="Order">
                    <el-input v-model="menu.sort_num" type="number" class="w200"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save">Save</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </main-layout>
</template>

<style scoped>

</style>